<template>
    <v-navigation-drawer stateless value="true" dark>
        <v-list expand>
            <template v-for="item in navigation">
                <v-list-group
                    no-action
                    :value="item.state"
                    :key="Math.random()"
                    :prepend-icon="item.icon"
                    @click="changeState(item.title)"
                    v-if="item.items">
                    <template slot="activator">
                        <v-list-item>
                            <v-list-item-title>
                                <template v-if="item.title === 'Заказы'">
                                    {{ item.title }}
                                    <span :class="`badge-count badge-count--new`" v-if="getOrdersCount">
										{{ getOrdersCount }}
									</span>
                                </template>
                                <template v-else>
                                    {{ item.title }}
                                    <span :class="`badge-count badge-count--new`" v-if="getBookingNewCount">
										{{ getBookingNewCount }}
									</span>
                                </template>
                            </v-list-item-title>
                        </v-list-item>
                    </template>

                    <v-list-item v-for="subItem in item.items" :key="Math.random()" :to="subItem.url">
                        <v-list-item-action>
                            <v-icon>{{ subItem.icon }}</v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                            <v-list-item-title v-if="subItem.for !== 'ended'">
                                {{ subItem.title }}
                                <template v-if="subItem.type === 'order'">
                                    <template v-if="subItem.for === 'new'">
										<span :class="`badge-count badge-count--${subItem.for}`"
                                              v-if="getOrdersNewCount">
											{{ getOrdersNewCount }}
										</span>
                                    </template>
                                    <template v-else>
										<span :class="`badge-count badge-count--${subItem.for}`"
                                              v-if="getOrdersInProgressCount">
											{{ getOrdersInProgressCount }}
										</span>
                                    </template>
                                </template>
                                <template v-else>
									<span :class="`badge-count badge-count--${subItem.for}`" v-if="getBookingNewCount">
										{{ getBookingNewCount }}
									</span>
                                </template>
                            </v-list-item-title>
                            <v-list-item-title v-else>
                                {{ subItem.title }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-item :to="item.url" :key="Math.random()" v-else>
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'orderBookingNavigation',
        data: () => ({
            navigation: [
                {
                    title: 'Главная',
                    icon: 'home',
                    url: '/'
                },
                {
                    title: 'Заказы',
                    icon: 'shopping_cart',
                    url: '#',
                    state: false,
                    items: [
                        {
                            title: 'Новые',
                            icon: 'fiber_new',
                            url: '/orderBooking/order/new',
                            type: 'order',
                            for: 'new'
                        },
                        {
                            title: 'В обработке',
                            icon: 'offline_bolt',
                            url: '/orderBooking/order/inProgress',
                            type: 'order',
                            for: 'progress'
                        },
                        {
                            title: 'Завершенные',
                            icon: 'done_all',
                            url: '/orderBooking/order/ended',
                            type: 'order',
                            for: 'ended'
                        },
                    ]
                },
                {
                    title: 'Бронирование',
                    icon: 'confirmation_number',
                    url: '#',
                    state: false,
                    items: [
                        {
                            title: 'Новые',
                            icon: 'fiber_new',
                            url: '/orderBooking/booking/new',
                            type: 'booking',
                            for: 'new'
                        },
                        {
                            title: 'Завершенные',
                            icon: 'done_all',
                            url: '/orderBooking/booking/ended',
                            type: 'booking',
                            for: 'ended'
                        }
                    ]
                }
            ]
        }),
        methods: {
            changeState (title) {
                let navigateItem = this.navigation.find(e => e.title === title)

                return navigateItem.state = !navigateItem.state
            }
        },
        computed: mapGetters([
            'getOrdersCount',
            'getOrdersNewCount',
            'getBookingNewCount',
            'getOrdersInProgressCount',
        ])
    }
</script>

<style lang="scss">.v {
    &-list {
        &__group {
            &__items {
                transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
            }
        }
    }
}
</style>
